module.exports = __webpack_public_path__ + "img/76125.9595f526.svg";